export default {
  methods: {
    encode(img) {
      if (img) {
        img = img.replace('http:/', 'https:/');
        return img.replace(/[()\s]/g, (c) => `%${c.charCodeAt(0).toString(16)}`);
      }
    },
  },
};
